import { CardApiClient } from './cardApiClient';
var operationsUrl = {
    getOperations: '/v1/operations',
    generateOperationsReport: '/v1/operations.xls'
};
export function getOperations(queryParams) {
    return CardApiClient.get("" + operationsUrl.getOperations + queryParams).then(function (response) { return response.data; });
}
export function generateOperationsReport(queryParams) {
    return CardApiClient.get("" + operationsUrl.generateOperationsReport + queryParams).then(function (response) { return response.data; });
}
